// The drawer's edge dragged (App's sidebar resizer): the sidebar's column
// sized a frame at a time by the shell's own `--sidebar`, rather than
// through the app's state, so the whole app is not drawn again at every
// frame of the drag. The width is the app's (`commit`) where the drag
// crosses the width the sidebar turns into a table at, and when it ends.
// While it lasts the body says so (lib/settledResize.js); `onEnd` undoes
// what the drag held in place. Returns what ends it.
export function dragSidebar({ startX, startWidth, shell, clamp, tableMin, commit, onEnd = null }) {
  document.body.classList.add("is-resizing-sidebar");
  let rafId = 0;
  let latestX = startX;
  let width = startWidth;
  const widthAt = () => clamp(startWidth + latestX - startX);

  const onMove = (moveEvent) => {
    latestX = moveEvent.clientX;
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      rafId = 0;
      const next = widthAt();
      const crossed = (next >= tableMin) !== (width >= tableMin);
      width = next;
      if (crossed || !shell) commit(next);
      else shell.style.setProperty("--sidebar", `${next}px`);
    });
  };

  const onUp = () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = 0;
    onEnd?.();
    document.body.classList.remove("is-resizing-sidebar");
    window.removeEventListener("pointermove", onMove);
    window.removeEventListener("pointerup", onUp);
    commit(widthAt());
  };

  window.addEventListener("pointermove", onMove);
  window.addEventListener("pointerup", onUp);
  return onUp;
}
